import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Header.css';

export default function Header() {
  const { user, logout, wallet } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/');
  };

  return (
    <header className="site-header">
      <div className="header-left">
        <NavLink to="/dashboard" className="header-logo">🀄 Triad-Ha</NavLink>
      </div>

      <nav className="header-nav">
        <NavLink to="/dashboard" className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}>
          Lobby
        </NavLink>
        {user?.role === 'admin' && (
          <NavLink to="/admin/tables" className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}>
            Tables
          </NavLink>
        )}
      </nav>

      <div className="header-right">
        <div className="header-wallet">
          <span className="header-wallet-label">Wallet</span>
          <span className="header-wallet-amount">${wallet?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
        </div>
        <div className="user-chip">
          <span className="user-avatar">{user?.name?.[0] ?? '?'}</span>
          <span className="user-name">{user?.name}</span>
          {user?.role === 'admin' && <span className="role-badge">Admin</span>}
        </div>
        <button className="btn-logout" onClick={handleLogout}>Log Out</button>
      </div>
    </header>
  );
}
